import { IReportService } from "../../service/report/ReportService";

export default class GetReport1ApplicantsInteractor {
  private reportService: IReportService;

  constructor(reportService) {
    this.reportService = reportService;
  }

  async execute(fullName: string) {
    return this.reportService.getReport1ApplicantList(fullName);
  }
}
